import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { IProductVariationFlavor } from 'src/interfaces';
import { requestCCApi } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

export const useCreateProductVariationFlavor = () => {
  return useMutation({
    mutationFn: createProductVariationFlavors,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.productVariationFlavors.all());
    },
  });
};

const createProductVariationFlavors = async (
  payload: Partial<IProductVariationFlavor>,
) => {
  const request = {
    name: payload.name,
  };

  const response = await requestCCApi({
    url: `/productVariationFlavors`,
    method: 'POST',
    data: { data: request },
  });

  return response;
};
